module.exports = __webpack_public_path__ + "static/media/femina_p_a.a2a07f9e.jpg";